"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Donut = void 0;
var _react = require("react");
var _Donut = _interopRequireDefault(require("./Donut.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const calcCircleSizeParams = size => {
  let width;
  let stokeWidth;
  if (size === 'small') {
    width = 100;
    stokeWidth = 4;
  } else if (size === 'medium') {
    width = 128;
    stokeWidth = 5;
  } else {
    width = 156;
    stokeWidth = 6;
  }
  const radius = width / 2 - stokeWidth * 2;
  const circumference = 2 * Math.PI * radius;
  return {
    width,
    stokeWidth,
    radius,
    circumference
  };
};
const getValidProps = props => {
  const {
    min: minProp,
    max: maxProp,
    value: valueProp
  } = props;
  let validMin = minProp;
  let validMax = maxProp;
  let validValue = valueProp;
  if (valueProp < minProp) {
    validValue = minProp;
  }
  if (valueProp > maxProp) {
    validValue = maxProp;
  }
  return {
    ...props,
    min: validMin,
    max: validMax,
    value: validValue
  };
};
const Donut = props => {
  const {
    min,
    max,
    value,
    unit,
    circleSize = 'medium'
  } = getValidProps(props);
  const circleParams = (0, _react.useMemo)(() => calcCircleSizeParams(circleSize), [circleSize]);
  const maxAngle = (0, _react.useMemo)(() => Math.round(value * 360 / (max - min)), [max, min, value]);
  const requestAnimationRef = (0, _react.useRef)();
  const currentAnimatedAngle = (0, _react.useRef)(0);
  const [animatedValue, setAnimatedValue] = (0, _react.useState)(0);
  const [strokeDasharray, setStrokeDasharray] = (0, _react.useState)(`0, ${circleParams.circumference}`);
  const styles = (0, _Donut.default)(circleParams.width, circleParams.stokeWidth, unit);
  const updateValues = (0, _react.useCallback)(() => {
    let angleIncrement = currentAnimatedAngle.current < maxAngle ? 4 : -4;
    const percentage = currentAnimatedAngle.current / 360 * 100;
    const angleStroke = Math.round(circleParams.circumference * percentage / 100);
    setStrokeDasharray(angleStroke + ', ' + circleParams.circumference);
    if (Math.abs(maxAngle - currentAnimatedAngle.current) >= Math.abs(angleIncrement)) {
      setAnimatedValue(Math.round((max - min) * percentage / 100));
      currentAnimatedAngle.current += angleIncrement;
      requestAnimationRef.current = window.requestAnimationFrame(updateValues);
    } else {
      setAnimatedValue(value);
    }
  }, [circleParams.circumference, min, max, value, maxAngle]);
  (0, _react.useEffect)(() => {
    if (requestAnimationRef.current) {
      cancelAnimationFrame(requestAnimationRef.current);
    }
    updateValues();
    return () => {
      if (requestAnimationRef.current) {
        cancelAnimationFrame(requestAnimationRef.current);
      }
    };
  }, [maxAngle, updateValues]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Donut'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      viewBox: `0 0 ${circleParams.width} ${circleParams.width}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        className: styles['cc-Donut__background-circle'],
        r: circleParams.radius
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        className: styles['cc-Donut__value-circle'],
        r: circleParams.radius,
        strokeDasharray: strokeDasharray
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Donut__text'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Donut__text__value'],
        children: animatedValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Donut__text__unit'],
        children: unit
      })]
    })]
  });
};
exports.Donut = Donut;